import { css, useTheme } from "@emotion/react";
import React from "react";
import SectionContainer from "core/Components/SectionContainer";
import Wrapper from "core/Components/Wrapper";
import StatementListItem from "elements/Components/StatementList/StatementListItem";

type Props = {
    data: StatementList,
}

const StatementList: React.FC<Props> = ({ data }) => {
    const theme = useTheme();

    const wrapperStyle = css`
        background-color: ${data.backgroundColour || theme.colours.white};
        padding: 113px 0 146px;

        ${theme.breakpoints.only('lg')} {
            padding: 100px 0 120px;
        };

        ${theme.breakpoints.down('xs')} {
            padding: 80px 0 100px;
        };
    `;

    const titleStyle = css`
        color: ${data.titleTextColour || theme.colours.black};
        text-align: center;
        font-size: 45px;
        font-weight: ${theme.fonts.weights.medium};
        margin-bottom: 82px;

        ${theme.breakpoints.only('lg')} {
            font-size: 42px;
            margin-bottom: 70px;
        };

        ${theme.breakpoints.down('xs')} {
            font-size: 42px;
            margin-bottom: 70px;
        };
    `;

    const listStyle = css`
        display: flex;
        justify-content: center;
        gap: 144px;
        width: 100%;

        ${theme.breakpoints.only('lg')} {
            gap: 80px;
        };

        ${theme.breakpoints.down('md')} {
            flex-wrap: wrap;
            gap: 90px;
            align-items: center;
        };

        ${theme.breakpoints.down('xs')} {
            gap: 50px;
        };
    `;

    return (
        <SectionContainer>
            <Wrapper flexDirection="column" css={wrapperStyle} useMinHeight={false}>
                <h2 css={titleStyle}>{data.titleText}</h2>
                <div css={listStyle}>
                    {data.items.map((item, index) => (
                        <StatementListItem key={`statement-item-${index}-${item.id}`} data={item} />
                    ))}
                </div>
            </Wrapper>
        </SectionContainer>
    );
}

export default StatementList;
